
export default {
    "reportGuid": null,
    "categories": [
        // God
        {
            "categoryName": "परमेश्वर",
            "categoryDescription": "परमेश्वर के साथ व्यक्तिगत सम्बन्ध",
            "data": [
                {
                    "name": "प्रत्येक दिन प्रार्थना में समय बिताना",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "प्रत्येक दिन बाइबिल पढ़ने में समय बितानाा",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "प्रत्येक दिन बाइबिल के वचन याद करने में समय बितानााा",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "प्रत्येक दिन मसीही पुस्तक पढ़ने में समय बिताना",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        // Family
        {
            "categoryName": "परिवार",
            "categoryDescription": "पारिवारिक संबंध",
            "data": [
                {
                    "name": "परिवार में शांति और खुशी है",
                    "description": "अपने घर में पत्नी, बच्चों और परिवार के अन्य सदस्यों के साथ",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "पारिवारिक आराधना की अगुआई किया",
                    "description": "प्रार्थना में, बाइबिल पढ़ने में, गीत गाने में",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने अपनी पत्नी और बच्चों के साथ प्रेम, धीरज और नम्रता से व्यवहार किया है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैंने अपनी पत्नी को मारा है या गाली गलौज किया है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        // Sexual Life
        {
            "categoryName": "यौन (सेक्स) जीवन",
            "categoryDescription": null,
            "data": [
                {
                    "name": "क्या इस हफ्ते मैंने कोई पोर्नोग्राफ़ी विडियो देखी है",
                    "description": "कोई यौन वीडियो या गैर महिलाओं की तस्वीरें?",
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते किसी महिला को देखकर मेरे मन  में सेक्स संबंधी गलत विचार आये हैं?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैंने अपने शरीर को गलत तरीके से छुआ है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        // Relationships with other people
        {
            "categoryName": "अन्य लोगों के साथ संबंध",
            "categoryDescription": null,
            "data": [
                {
                    "name": "क्या इस हफ्ते मैंने किसी को यीशु मसीह के बारे में बताया या किसी को  सुसमाचार सुनाया है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते अपनी पत्नी के अलावा मैं किसी अन्य महिला से ऑनलाइन, अपने मोबाइल पर या व्यक्तिगत रूप से बातचीत किया हूँ ?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैंने कोई झूठ बोला है, यहाँ तक कि कोई ऐसा झूठ, जो मुझे न चाहते हुए भी बोलना ही पड़ा?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या किसी के साथ मेरा कोई मनमुटाव है या नाराजगी चल रही है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या किसी ने मुझे किसी प्रकार की चोट पहुँचाई या मैंने किसी और को चोट पहुँचाई है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        // Time
        {
            "categoryName": "स्वास्थ्य",
            "categoryDescription": null,
            "data": [
                {
                    "name": "खाना (बहुत कम या बहुत ज्यादा खाना खाने की समस्या?)",
                    "description": "1 = बहुत कम, 3 = सामान्य, 5 = बहुत ज्यादा",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "नींद (बहुत कम नींद आ रही या बहुत अधिक सोने से की समस्या?)",
                    "description": "1 = बहुत कम, 3 = सामान्य, 5 = बहुत ज्यादा",
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        // health
        {
            "categoryName": "समय",
            "categoryDescription": "मैं अपने खाली समय का उपयोग कैसे कर रहा हूँ?",
            "data": [
                {
                    "name": "इंटरनेट पर बिताया गया समय: फेसबुक, यूट्यूब, खेल, समाचार आदि।",
                    "description": "1 = बहुत कम, 3 = ठीक ठीक, 5 = बहुत ज्यादा",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "फिल्मों या वीडियो गेम पर बिताया गया समय",
                    "description": "1 = बहुत कम, 3 = ठीक ठीक, 5 = बहुत ज्यादा",
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        // leadership
        {
            "categoryName": "अगुआ",
            "categoryDescription": "दूसरों के लिए आदर्श बनकर जीवन बिताना",
            "data": [
                {
                    "name": "क्या मैं अपने चर्च के लोगों के लिए रोज प्रार्थना कर रहा हूँ?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या मैं पिछले रविवार को KBC की आराधना में गया था?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैंने अपने घर पर लोगों को संगति के लिए बुलाया था?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या मेरे पास बाइबिल से संबंधित कोई प्रश्न है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        {
            "categoryName": "पैसे से मेरा संबंध",
            "categoryDescription": null,
            "data": [
                {
                    "name": "क्या मैंने कुछ फ़ालतू पैसे खर्च किया है जो मुझे नहीं करना चाहिए था?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैंने उदारता से दान दिया है?",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने अधिक पैसा कमाने के लिए किसी भी तरह से झूठ बोला या धोखा दिया है?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "क्या इस हफ्ते मैं और अधिक पैसा न होने से निराश हूँ?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }                
            ]
        },
        {
            "categoryName": "क्या मैं अपने जीवन में पाप से संघर्ष कर रहा हूँ?",
            "categoryDescription": "1= अच्छा नहीं, 3=ठीक ठाक है, 5=वास्तव में अच्छा है",
            "data": [
                {
                    "name": "गुस्सा/निराशा: क्या इस हफ्ते मैं पत्नी, बच्चों, परिवार या दोस्तों या किसी घटना से गुस्सा या नाराज़ रहा हूँ?",
                    "description": "गुस्सा या नाराज रहा हूँ/ गुस्सा या नाराज नहीं होने के लिए संघर्ष कर रहा था/ गुस्सा या नाराज नहीं रहा हूँ।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैं व्याकुल या चिंता या भय में रहा हूँ?",
                    "description": "व्याकुल या चिंता या भय में रहा हूँ/ व्याकुल या चिंता या भय में नहीं होने के लिए संघर्ष कर रहा था/व्याकुल या चिंता या भय में नहीं रहा हूँ।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने दूसरों के बारे में गपशप किया है?",
                    "description": "गपशप किया है/  गपशप नहीं करने के लिए संघर्ष कर रहा था/ गपशप नहीं किया है।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने दूसरों को क्षमा किया है?",
                    "description": "क्षमा किया है/  क्षमा करने के लिए संघर्ष कर रहा था/ क्षमा नहीं कर पा रहा हूँ।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "लोभ या मूर्तिपूजा: क्या मैंने अपने जीवन में परमेश्वर के अलावा किसी और चीज को पहला स्थान दिया है?",
                    "description": "किसी और चीज को पहला स्थान दिया है/ किसी और चीज को पहला स्थान न देने के लिए संघर्ष कर रहा था/ किसी और चीज को पहला स्थान नहीं दिया है।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैं निराशा/अवसाद से परेशान रहा हूँ?",
                    "description": "निराशा या अवसाद से परेशान रहा हूँ/ निराशा या अवसाद से दूर रहने के लिए संघर्ष कर रहा था/निराशा या अवसाद से परेशान नहीं रहा हूँ।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैं आलस या मेहनत नहीं करने की आदत से परेशान रहा हूँ?",
                    "description": "आलस या मेहनत नहीं करने की आदत से परेशान रहा हूँ/ आलस या मेहनत नहीं करने की आदत से संघर्ष कर रहा था/ आलस या मेहनत नहीं करने की आदत से परेशान नहीं था।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैं सेक्स संबंधी गलत और बुरे विचारों से परेशान रहा हूँ?",
                    "description": "सेक्स संबंधी गलत और बुरे विचारों से परेशान रहा हूँ/ सेक्स संबंधी गलत और बुरे विचारों से बचने के लिए संघर्ष कर रहा था/सेक्स संबंधी गलत और बुरे विचारों से परेशान नहीं रहा हूँ।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने कुछ ऐसा किया है जिससे मुझे शर्मिंदगी महसूस हो रही थी?",
                    "description": "शर्मिंदगी महसूस हो रही थी/ शर्मिंदगी से बचने के लिए संघर्ष कर रहा था/ऐसा कुछ नहीं किया कि शर्मिंदगी महसूस हो।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने अपने ऊपर घमंड किया या अन्य लोगों के साथ ऐसा व्यवहार किया जैसे मैं उनसे बेहतर हूँ?",
                    "description": "मैंने अपने ऊपर घमंड किया/ मैं घमंड से बचने के लिए संघर्ष कर रहा था / मैंने अपने ऊपर घमंड नहीं किया। ",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने स्वार्थी होकर दूसरों के बजाय अपने बारे में पहले सोचा?",
                    "description": "मैं स्वार्थी होकर दूसरों के बजाय अपने बारे में पहले सोचा/ मैं स्वार्थी होकर दूसरों के बजाय अपने बारे में पहले नहीं सोचने के लिए संघर्ष कर रहा था/ मैं स्वार्थी होकर दूसरों के बजाय अपने बारे में पहले नहीं सोचा।",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "क्या इस हफ्ते मैंने शराब पी थी?",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
            ]
        },
        //Details/ summary
        {
            "categoryName": "विवरण",
            "categoryDescription": null,
            "data": [
                {
                    "name": "विवरण",
                    "description": "क्या आप अपनी बातों का कोई स्पष्टीकरण देना चाहते हैं ? अपने पापों को स्वीकार करना चाहते हैं ?आपके पास कोई प्रार्थना अनुरोध है?",
                    "answer": null,
                    "answerType": 1
                }
            ]
        }
    ]
}
